import React from 'react'
import { IonChip, IonCol, IonGrid, IonIcon, IonLabel, IonRow } from '@ionic/react'
import { checkmarkSharp } from 'ionicons/icons'
import '../../../../../components/grid/Grid.component.css'
import './ChartSummaryEventHeader.content.css'

interface IChartSummaryRowHeaderProps {
  title: string
  time?: string
  date?: string
  isPta?: boolean
  children?: React.ReactNode
}

const ChartSummaryRowHeader: React.FC<IChartSummaryRowHeaderProps> = ({ title, time, date, isPta, children }) => (
  <IonLabel className='ion-text-wrap grid-ion-label qa-addendum-event-header'>
    <IonGrid className='ion-no-padding'>
      <IonRow className='ion-align-items-start'>
        <IonCol className='timeline-item-header-col qa-addendum-event-time-col'>
          {isPta ? (
            <IonChip className='grid-header-chip'>
              <IonIcon className='header-checkmark' icon={checkmarkSharp} />
              <IonLabel>PTA</IonLabel>
            </IonChip>
          ) : null}
          {time ? <h2 className='fw-700 font-size-16'>{time}</h2> : null}
          {date ? <h4 className='grid-label-subheader'>{date}</h4> : null}
        </IonCol>
        <IonCol className='padding-start-mobile qa-addendum-event-content-col'>
          <h2 className='qa-addendum-event-title fw-700 font-size-16'>{title}</h2>
          {children}
        </IonCol>
      </IonRow>
    </IonGrid>
  </IonLabel>
)

export default ChartSummaryRowHeader
